import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import Events from '../../api/event'
//import lizaProfileIMG from "../../images/profileIMG/lizaProfileIMG.png";

const EventsSection = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    var settings = {
        dots: false,
        arrows: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,

        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false,
                    infinite: true,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    centerMode: false,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <section className={`events-section section-padding ${props.eClass}`}>
            <div className="container">
                <div className="row">
                    <div className="col col-lg-5 col-12">
                        <div className="section-title">
                            <span>#Events Fundraising</span>
                            <h2><span>Fundraising </span>events,Please join.</h2>
                        </div>
                        <div className="about-details">
                            <p> At our core, we empower individuals and strengthen communities through education, mentorship, and compassionate support. Guided by our core values of integrity, respect, community, passion, and diversity, we are committed to creating opportunities that foster growth, resilience, and hope, ensuring no one faces life’s challenges alone.</p>
                        </div>
                        <Link onClick={ClickHandler} to="/event-single/Help-The-Poor">See Our Next Event!</Link>
                    </div>
                    <div className="col col-lg-7 col-12">
                        <div className="events-slider-holder">
                            <div className="events-slider">
                                <Slider {...settings}>
                                    {Events.slice(0, 6).map((event, citem) => (
                                        <div className="events-slider-item" key={citem}>
                                            <div className="grid">
                                                <div className="img-holder">
                                                    <img
                                                        src={event.eImg}
                                                        alt=""
                                                        style={{
                                                            width: "100%",        // or any fixed value like "650px"
                                                            height: "100%",       // or "687px"
                                                            objectFit: "cover",   // maintains aspect ratio and fills container
                                                            borderRadius: "10px", // optional
                                                        }}
                                                    />
                                                </div>
                                                <div className="details">
                                                    <div className="inner">
                                                        <h3><Link onClick={ClickHandler} to={`/event-single/${event.slug}`}>{event.eTitle}</Link></h3>
                                                        <p>{event.date}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default EventsSection;